import { CSSProperties } from 'react';
import { commonStyles, styleConstants } from './common';

export const addressInputStyles: Record<string, CSSProperties> = {
  title: commonStyles.title,
  nextButton: commonStyles.nextButton,
  leftAlignedText: commonStyles.leftAlignedText,

  mapContainer: {
    height: 'calc(100% - 55px)',
    width: '98%',
    position: 'relative',
    borderRadius: styleConstants.sizes.borderRadius,
    overflow: 'hidden',
    marginTop: styleConstants.sizes.spacing.lg,
  },

  mapContainerDesktop: {
    flex: 1,
    width: '100%',
    position: 'relative',
    borderRadius: styleConstants.sizes.borderRadius,
    overflow: 'hidden',
  },

  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },

  geocoderContainer: {
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 1,
    width: 'calc(100% - 20px)',
    textAlign: 'left' as const,
  },

  addressDisplayContainer: {
    marginTop: styleConstants.sizes.spacing.lg,
    padding: 12,
    backgroundColor: '#f5f5f5',
    borderRadius: styleConstants.sizes.borderRadius,
  },

  instructionStep: {
    marginBottom: 12,
    display: 'flex',
    alignItems: 'flex-start',
  },

  stepNumber: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: styleConstants.colors.primary,
    color: 'white',
    fontSize: 14,
    marginRight: styleConstants.sizes.spacing.sm,
    fontWeight: 500,
  },

  stepText: {
    flex: 1,
    textAlign: 'left' as const,
  },

  infoText: {
    marginTop: styleConstants.sizes.spacing.lg,
    color: '#666',
    fontSize: 14,
    textAlign: 'left' as const,
  },

  desktopContentPadding: {
    padding: styleConstants.sizes.spacing.lg,
    flex: 1,
    overflow: 'auto',
  },
};
